export function pushObjValue(obj) {
    let newArr = [];
    Object.values(obj).map(value => {
        newArr.unshift(value);
    });
    return newArr;
}